import { LoadingButton } from '@mui/lab';
import {
  Box,
  Card,
  DialogContent,
  DialogContentText,
  Grid,
  TextField,
  styled
} from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';

import DialogTitle from '@mui/material/DialogTitle';
import { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getSpecificInvoice, updateInvoice } from 'app/contexts/reducers/transaction/invoiceSlice';
import { calculateGST } from '../helper/invoiceTotal';
const StyledCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '24px !important',
  background: theme.palette.background.paper,
  [theme.breakpoints.down('sm')]: { padding: '16px !important' }
}));
const ContentBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'flex-start',
  '& small': { color: theme.palette.text.secondary },
  '& .icon': { opacity: 0.6, fontSize: '44px', color: theme.palette.primary.main }
}));

export default function UpdateInvoiceDialog({
  open,
  onClose,
  updateInvoiceId,
  handleApiCall,
  apiCall,
  handleClickSuccess,
  setError,
  handleClickError
}) {
  const dispatch = useDispatch();

  const { specificInvoiceData, isSpecificInvoiceSuccess } = useSelector((state) => state.invoice);

  const [updateValue, setUpdateValue] = useState({
    invoiceId: updateInvoiceId,
    selfWeight: '',
    orderType: '',
    state: '',
    usedPcs: '',
    labourChargePerPcs: '',
    labourCharge: '',
    diamondCaratPrice: '',
    diamondPrice: '',
    productPrice: '',
    extraCost: 0,
    remark: '',
    purity: '',
    panNumber: '',
    gstNumber: '',
    cgstPercentage: '',
    cgstValue: '',
    dcgstPercentage: '',
    dcgstValue: '',
    digstPercentage: '',
    digstValue: '',
    dsgstPercentage: '',
    dsgstValue: '',
    igstPercentage: '',
    igstValue: '',
    lcgstPercentage: '',
    lcgstValue: '',
    ligstPercentage: '',
    ligstValue: '',
    lsgstPercentage: '',
    lsgstValue: '',
    sgstPercentage: '',
    sgstValue: '',
    extraCostCgstPercentage: '',
    extraCostCgstValue: '',
    extraCostIgstPercentage: '',
    extraCostIgstValue: '',
    extraCostSgstPercentage: '',
    extraCostSgstValue: '',
    extraCostValue: '',
    subTotal: '',
    total: '',
    billNumber: '',
    address: '',
    mobileNumber: ''
  });

  const [loading, setLoading] = useState(false);
  const [specificInvoiceDetails, setSpecificInvoiceDetails] = useState();
  useEffect(() => {
    dispatch(getSpecificInvoice({ invoiceId: updateInvoiceId }));
  }, [dispatch, updateInvoiceId, apiCall]);
  useEffect(() => {
    if (isSpecificInvoiceSuccess) {
      setSpecificInvoiceDetails(specificInvoiceData.data.data[0]);
    }
  }, [isSpecificInvoiceSuccess, specificInvoiceData, updateInvoiceId]);

  useEffect(() => {
    if (isSpecificInvoiceSuccess) {
      specificInvoiceDetails &&
        setUpdateValue({
          selfWeight: specificInvoiceDetails.self_weight,
          orderType: specificInvoiceDetails.order_type,
          state: specificInvoiceDetails.state,
          usedPcs: specificInvoiceDetails.studd_pieces,
          labourChargePerPcs: specificInvoiceDetails.labour_charge_per_pcs,
          labourCharge: specificInvoiceDetails.labour_charge,
          diamondCaratPrice: specificInvoiceDetails.diamond_carat_price,
          diamondPrice: specificInvoiceDetails.diamond_price,
          productPrice: specificInvoiceDetails.product_price,
          extraCost: specificInvoiceDetails.extra_cost,
          remark: specificInvoiceDetails.remark,
          purity: specificInvoiceDetails.purity,
          cgstPercentage: specificInvoiceDetails.cgst_percentage,
          cgstValue: specificInvoiceDetails.cgst_value,
          dcgstPercentage: specificInvoiceDetails.dcgst_percentage,
          dcgstValue: specificInvoiceDetails.dcgst_value,
          digstPercentage: specificInvoiceDetails.digst_percentage,
          digstValue: specificInvoiceDetails.digst_value,
          dsgstPercentage: specificInvoiceDetails.dsgst_percentage,
          dsgstValue: specificInvoiceDetails.dsgst_value,
          igstPercentage: specificInvoiceDetails.igst_percentage,
          igstValue: specificInvoiceDetails.igst_value,
          lcgstPercentage: specificInvoiceDetails.lcgst_percentage,
          lcgstValue: specificInvoiceDetails.lcgst_value,
          ligstPercentage: specificInvoiceDetails.ligst_percentage,
          ligstValue: specificInvoiceDetails.ligst_value,
          lsgstPercentage: specificInvoiceDetails.lsgst_percentage,
          lsgstValue: specificInvoiceDetails.lsgst_value,
          sgstPercentage: specificInvoiceDetails.sgst_percentage,
          sgstValue: specificInvoiceDetails.sgst_value,
          extraCostCgstPercentage: specificInvoiceDetails.extra_cost_cgst_percentage,
          extraCostCgstValue: specificInvoiceDetails.extra_cost_cgst_value,
          extraCostIgstPercentage: specificInvoiceDetails.extra_cost_igst_percentage,
          extraCostIgstValue: specificInvoiceDetails.extra_cost_igst_value,
          extraCostSgstPercentage: specificInvoiceDetails.extra_cost_sgst_percentage,
          extraCostSgstValue: specificInvoiceDetails.extra_cost_sgst_value,
          extraCostValue: specificInvoiceDetails.extra_cost_value,
          subTotal: specificInvoiceDetails.sub_total,
          total: specificInvoiceDetails.total,
          panNumber: specificInvoiceDetails.pan_number,
          gstNumber: specificInvoiceDetails.gst_number,
          billNumber: specificInvoiceDetails.invoice_number,
          address: specificInvoiceDetails.address,
          mobileNumber: specificInvoiceDetails.mobile_number
        });
    }
    // eslint-disable-next-line
  }, [
    updateInvoiceId,
    isSpecificInvoiceSuccess,
    specificInvoiceDetails,
    specificInvoiceData,
    open
  ]);

  useEffect(() => {
    // Ensure both values are integers before performing multiplication
    const labourChargePerPcs = parseInt(updateValue.labourChargePerPcs);
    const usedPcs = parseInt(updateValue.usedPcs);

    // Check if both values are valid integers
    if (!isNaN(labourChargePerPcs) && !isNaN(usedPcs)) {
      // Perform the multiplication and update the state
      const result = labourChargePerPcs * usedPcs;
      setUpdateValue((prev) => ({ ...prev, labourCharge: result }));
    }
  }, [updateValue.labourChargePerPcs, updateValue.usedPcs]);
  useEffect(() => {
    // Ensure both values are integers before performing multiplication
    const diamondCaratPrice = parseInt(updateValue.diamondCaratPrice);
    const selfWeight = parseFloat(parseFloat(updateValue.selfWeight).toFixed(3));

    // Check if both values are valid integers
    if (!isNaN(diamondCaratPrice) && !isNaN(selfWeight)) {
      // Perform the multiplication and update the state
      const result = diamondCaratPrice * selfWeight;
      setUpdateValue((prev) => ({ ...prev, diamondPrice: result }));
    }
  }, [updateValue.diamondCaratPrice, updateValue.selfWeight]);
  useEffect(() => {
    // Ensure all values are numbers before performing addition
    const labourCharge = parseInt(updateValue.labourCharge);
    const diamondPrice = parseInt(updateValue.diamondPrice);
    const productPrice = parseInt(updateValue.productPrice);
    const extraCost = parseInt(updateValue.extraCost);

    // Check if all values are valid numbers
    if (!isNaN(labourCharge) && !isNaN(diamondPrice) && !isNaN(productPrice) && !isNaN(extraCost)) {
      // Perform the addition and update the state
      const subTotal = labourCharge + diamondPrice + productPrice;
      const total = subTotal + extraCost;
      setUpdateValue((prev) => ({ ...prev, total: total, subTotal: subTotal }));
    }
  }, [
    updateValue.labourCharge,
    updateValue.diamondPrice,
    updateValue.productPrice,
    updateValue.extraCost,
    setUpdateValue
  ]);
  useEffect(() => {
    async function fetchData() {
      const { orderType, state, subTotal, labourCharge, diamondPrice, extraCost } = updateValue;

      const gstAddedValue = await calculateGST(
        orderType,
        state,
        subTotal,
        diamondPrice,
        labourCharge,
        extraCost
      );

      const {
        sgstPercentage,
        cgstPercentage,
        igstPercentage,
        dcgstPercentage,
        dsgstPercentage,
        lcgstPercentage,
        lsgstPercentage,
        digstPercentage,
        ligstPercentage,
        sgstValue,
        cgstValue,
        igstValue,
        dcgstValue,
        dsgstValue,
        lcgstValue,
        lsgstValue,
        digstValue,
        ligstValue,
        extraCostCGSTPercentage,
        extraCostSGSTPercentage,
        extraCostIGSTPercentage,
        extraCostCGSTValue,
        extraCostSGSTValue,
        extraCostIGSTValue,
        extraCostWithGST,
        totalValueWithGST,
        roundedOffValue
      } = gstAddedValue;
      setUpdateValue({
        ...updateValue,
        cgstPercentage: parseFloat(parseFloat(cgstPercentage).toFixed(2)),
        cgstValue: parseFloat(parseFloat(cgstValue).toFixed(2)),
        sgstPercentage: parseFloat(parseFloat(sgstPercentage).toFixed(2)),
        sgstValue: parseFloat(parseFloat(sgstValue).toFixed(2)),
        igstPercentage: Number(igstPercentage),
        igstValue: parseFloat(parseFloat(igstValue).toFixed(2)),
        dcgstPercentage: parseFloat(parseFloat(dcgstPercentage).toFixed(2)),
        dcgstValue: parseFloat(parseFloat(dcgstValue).toFixed(2)),
        dsgstPercentage: parseFloat(parseFloat(dsgstPercentage).toFixed(2)),
        dsgstValue: parseFloat(parseFloat(dsgstValue).toFixed(2)),
        lcgstPercentage: parseFloat(parseFloat(lcgstPercentage).toFixed(2)),
        lcgstValue: parseFloat(parseFloat(lcgstValue).toFixed(2)),
        lsgstPercentage: parseFloat(parseFloat(lsgstPercentage).toFixed(2)),
        lsgstValue: parseFloat(parseFloat(lsgstValue).toFixed(2)),
        digstPercentage: parseFloat(parseFloat(digstPercentage).toFixed(2)),
        digstValue: parseFloat(parseFloat(digstValue).toFixed(2)),
        ligstPercentage: parseFloat(parseFloat(ligstPercentage).toFixed(2)),
        ligstValue: parseFloat(parseFloat(ligstValue).toFixed(2)),
        extraCostCgstPercentage: parseFloat(parseFloat(extraCostCGSTPercentage).toFixed(2)),
        extraCostCgstValue: parseFloat(parseFloat(extraCostCGSTValue).toFixed(2)),
        extraCostSgstPercentage: parseFloat(parseFloat(extraCostSGSTPercentage).toFixed(2)),
        extraCostSgstValue: parseFloat(parseFloat(extraCostSGSTValue).toFixed(2)),
        extraCostIgstPercentage: parseFloat(parseFloat(extraCostIGSTPercentage).toFixed(2)),
        extraCostIgstValue: parseFloat(parseFloat(extraCostIGSTValue).toFixed(2)),
        extraCostValue: parseFloat(parseFloat(extraCostWithGST).toFixed(2)),
        total: totalValueWithGST,
        roundOff: roundedOffValue
      });
    }

    fetchData();
    // eslint-disable-next-line
  }, [updateValue.subTotal, updateValue.total]);
  async function handleUpdate() {
    try {
      if (
        updateValue.labourChargePerPcs &&
        updateValue.labourChargePerPcs > 0 &&
        updateValue.total &&
        updateValue.total > 0 &&
        updateValue.subTotal &&
        updateValue.subTotal > 0
      ) {
        const updateInvoiceDetails = { ...updateValue };
        const propertiesToConvert = [
          'selfWeight',
          'usedPcs',
          'labourChargePerPcs',
          'diamondCaratPrice',
          'diamondPrice',
          'labourCharge',
          'productPrice',
          'extraCost',
          'subTotal',
          'total'
        ];
        propertiesToConvert.forEach((property) => {
          if (updateInvoiceDetails.hasOwnProperty(property)) {
            if (property === 'usedWeight' || property === 'selfWeight') {
              updateInvoiceDetails[property] = parseFloat(
                parseFloat(updateInvoiceDetails[property]).toFixed(3)
              );
            } else {
              updateInvoiceDetails[property] = parseInt(updateInvoiceDetails[property]);
            }
          }
        });
        Object.keys(updateInvoiceDetails).forEach((key) => {
          if (updateInvoiceDetails[key] === '') {
            delete updateInvoiceDetails[key];
          }
          if (key === 'employeeName') {
            updateInvoiceDetails[key] = updateInvoiceDetails[key].join(', ');
          }
        });
        const responseValue = await dispatch(
          updateInvoice({ invoiceId: updateInvoiceId, updateInvoiceDetails })
        );
        if (!responseValue.hasOwnProperty('error')) {
          onClose();
          handleClickSuccess('Invoice Updated successfully!!');
          handleApiCall();
          setLoading(false);
        } else {
          throw responseValue;
        }
      } else {
        handleClickError();
        setError({ payload: 'Please Fill Mandatory Data!' });
        setLoading(false);
      }
    } catch (e) {
      handleClickError();
      setError(e);
      setLoading(false);
    }
  }

  return (
    <Box>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth='md'
        fullWidth
        aria-labelledby='form-dialog-title'
      >
        <DialogTitle id='form-dialog-title'>Update Invoice</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: '10px' }}>
            You can Update Invoice Details From Here
          </DialogContentText>

          <Grid container spacing={3} sx={{ mb: '24px' }}>
            <Grid item xs={12} md={12}>
              <StyledCard elevation={6}>
                <Grid container>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <ContentBox>
                      <TextField
                        id='billNumber'
                        type='text'
                        margin='dense'
                        size='small'
                        label='Bill Number'
                        disabled
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={updateValue.billNumber}
                      />
                    </ContentBox>
                    <ContentBox>
                      <TextField
                        id='orderType'
                        type='text'
                        margin='dense'
                        size='small'
                        label='Order Type'
                        required
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={updateValue.orderType}
                      />
                    </ContentBox>
                    <ContentBox>
                      <TextField
                        id='usedPcs'
                        type='number'
                        margin='dense'
                        size='small'
                        label='Used Piece'
                        required
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={updateValue.usedPcs}
                      />
                    </ContentBox>
                    <ContentBox>
                      <TextField
                        id='labourChargePerPcs'
                        type='number'
                        margin='dense'
                        size='small'
                        label='Labour/Piece Charge'
                        required
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={updateValue.labourChargePerPcs}
                        onChange={(e) => {
                          setUpdateValue({ ...updateValue, labourChargePerPcs: e.target.value });
                        }}
                      />
                    </ContentBox>
                    <ContentBox>
                      {updateValue.orderType.toLowerCase() === 'job-work' &&
                        updateValue.state.toLowerCase() === 'gujarat' && (
                          <TextField
                            id='cgstPercentage'
                            type='number'
                            margin='dense'
                            size='small'
                            label='CGST %'
                            InputLabelProps={{ shrink: true }}
                            sx={{ my: 1, width: '80%' }}
                            variant='standard'
                            value={updateValue.cgstPercentage}
                          />
                        )}
                      {updateValue.orderType.toLowerCase() === 'self' &&
                        updateValue.state.toLowerCase() === 'gujarat' && (
                          <TextField
                            id='lcgstPercentage'
                            type='number'
                            margin='dense'
                            size='small'
                            label='L-CGST %'
                            InputLabelProps={{ shrink: true }}
                            sx={{ my: 1, width: '80%' }}
                            variant='standard'
                            value={updateValue.lcgstPercentage}
                          />
                        )}
                      {updateValue.orderType.toLowerCase() === 'job-work' &&
                        updateValue.state.toLowerCase() !== 'gujarat' && (
                          <TextField
                            id='igstPercentage'
                            type='number'
                            margin='dense'
                            size='small'
                            label='IGST %'
                            InputLabelProps={{ shrink: true }}
                            sx={{ my: 1, width: '80%' }}
                            variant='standard'
                            value={updateValue.igstPercentage}
                          />
                        )}
                      {updateValue.orderType.toLowerCase() === 'self' &&
                        updateValue.state.toLowerCase() !== 'gujarat' && (
                          <TextField
                            id='ligstPercentage'
                            type='number'
                            margin='dense'
                            size='small'
                            label='L-IGST %'
                            InputLabelProps={{ shrink: true }}
                            sx={{ my: 1, width: '80%' }}
                            variant='standard'
                            value={updateValue.ligstPercentage}
                          />
                        )}
                    </ContentBox>
                    <ContentBox>
                      {updateValue.orderType.toLowerCase() === 'job-work' &&
                        updateValue.state.toLowerCase() === 'gujarat' && (
                          <TextField
                            id='sgstPercentage'
                            type='number'
                            margin='dense'
                            size='small'
                            label='SGST %'
                            InputLabelProps={{ shrink: true }}
                            sx={{ my: 1, width: '80%' }}
                            variant='standard'
                            value={updateValue.sgstPercentage}
                          />
                        )}
                      {updateValue.orderType.toLowerCase() === 'self' &&
                        updateValue.state.toLowerCase() === 'gujarat' && (
                          <TextField
                            id='lsgstPercentage'
                            type='number'
                            margin='dense'
                            size='small'
                            label='L-SGST %'
                            InputLabelProps={{ shrink: true }}
                            sx={{ my: 1, width: '80%' }}
                            variant='standard'
                            value={updateValue.lsgstPercentage}
                          />
                        )}
                      {updateValue.orderType.toLowerCase() === 'self' &&
                        updateValue.state.toLowerCase() !== 'gujarat' && (
                          <TextField
                            id='digstPercentage'
                            type='number'
                            margin='dense'
                            size='small'
                            label='D-IGST %'
                            InputLabelProps={{ shrink: true }}
                            sx={{ my: 1, width: '80%' }}
                            variant='standard'
                            value={updateValue.digstPercentage}
                          />
                        )}
                    </ContentBox>
                    <ContentBox>
                      {updateValue.orderType.toLowerCase() === 'self' &&
                        updateValue.state.toLowerCase() === 'gujarat' && (
                          <TextField
                            id='dcgstPercentage'
                            type='number'
                            margin='dense'
                            size='small'
                            label='D-CGST %'
                            InputLabelProps={{ shrink: true }}
                            sx={{ my: 1, width: '80%' }}
                            variant='standard'
                            value={updateValue.dcgstPercentage}
                          />
                        )}
                    </ContentBox>
                    <ContentBox>
                      {updateValue.orderType.toLowerCase() === 'self' &&
                        updateValue.state.toLowerCase() === 'gujarat' && (
                          <TextField
                            id='dsgstPercentage'
                            type='number'
                            margin='dense'
                            size='small'
                            label='D-SGST %'
                            InputLabelProps={{ shrink: true }}
                            sx={{ my: 1, width: '80%' }}
                            variant='standard'
                            value={updateValue.dsgstPercentage}
                          />
                        )}
                    </ContentBox>

                    <ContentBox>
                      {updateValue.orderType.toLocaleLowerCase() === 'self' && (
                        <TextField
                          id='diamondCaretPrice'
                          type='number'
                          margin='dense'
                          size='small'
                          label='Diamond Caret Charge'
                          required
                          InputLabelProps={{ shrink: true }}
                          sx={{ my: 1, width: '80%' }}
                          variant='standard'
                          value={updateValue.diamondCaratPrice}
                          onChange={(e) => {
                            setUpdateValue({ ...updateValue, diamondCaratPrice: e.target.value });
                          }}
                        />
                      )}
                    </ContentBox>

                    <ContentBox>
                      {updateValue.orderType === 'self' && (
                        <TextField
                          id='diamondCaretPrice'
                          type='number'
                          margin='dense'
                          size='small'
                          label='Diamond Caret Charge'
                          required
                          InputLabelProps={{ shrink: true }}
                          sx={{ my: 1, width: '80%' }}
                          variant='standard'
                          value={updateValue.diamondCaratPrice}
                          onChange={(e) => {
                            setUpdateValue({ ...updateValue, diamondCaratPrice: e.target.value });
                          }}
                        />
                      )}
                    </ContentBox>

                    <ContentBox>
                      <TextField
                        id='productPrice'
                        type='number'
                        margin='dense'
                        size='small'
                        label='Product Price'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={updateValue.productPrice}
                        onChange={(e) => {
                          setUpdateValue({ ...updateValue, productPrice: e.target.value });
                        }}
                      />
                    </ContentBox>
                    <ContentBox>
                      {updateValue.state.toLowerCase() === 'gujarat' &&
                        (updateValue.orderType.toLowerCase() === 'job-work' ||
                          updateValue.orderType.toLowerCase() === 'self') && (
                          <TextField
                            id='extraCostCgstPercentage'
                            type='number'
                            margin='dense'
                            size='small'
                            label='Extra-Cost-CGST %'
                            InputLabelProps={{ shrink: true }}
                            sx={{ my: 1, width: '80%' }}
                            variant='standard'
                            value={updateValue.extraCostCgstPercentage}
                          />
                        )}
                      {(updateValue.orderType.toLowerCase() === 'job-work' ||
                        updateValue.orderType.toLowerCase() === 'self') &&
                        updateValue.state.toLowerCase() !== 'gujarat' && (
                          <TextField
                            id='extraCostIgstPercentage'
                            type='number'
                            margin='dense'
                            size='small'
                            label='Extra-Cost-IGST %'
                            InputLabelProps={{ shrink: true }}
                            sx={{ my: 1, width: '80%' }}
                            variant='standard'
                            value={updateValue.extraCostIgstPercentage}
                          />
                        )}
                    </ContentBox>
                    <ContentBox>
                      {updateValue.state.toLowerCase() === 'gujarat' &&
                        (updateValue.orderType.toLowerCase() === 'job-work' ||
                          updateValue.orderType.toLowerCase() === 'self') && (
                          <TextField
                            id='extraCostSgstPercentage'
                            type='number'
                            margin='dense'
                            size='small'
                            label='Extra-Cost-SGST %'
                            InputLabelProps={{ shrink: true }}
                            sx={{ my: 1, width: '80%' }}
                            variant='standard'
                            value={updateValue.extraCostSgstPercentage}
                          />
                        )}
                    </ContentBox>
                    <ContentBox>
                      <TextField
                        id='purity'
                        type='text'
                        margin='dense'
                        size='small'
                        label='Purity'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={updateValue.purity}
                        onChange={(e) => {
                          setUpdateValue({ ...updateValue, purity: e.target.value });
                        }}
                      />
                    </ContentBox>
                    <ContentBox>
                      <TextField
                        id='panNumber'
                        type='text'
                        margin='dense'
                        size='small'
                        label='Pan Number'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={updateValue.panNumber}
                        onChange={(e) => {
                          setUpdateValue({ ...updateValue, panNumber: e.target.value });
                        }}
                      />
                    </ContentBox>
                    <ContentBox>
                      <TextField
                        id='subTotal'
                        type='number'
                        margin='dense'
                        size='small'
                        label='Sub-Total'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={updateValue.subTotal}
                      />
                    </ContentBox>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <ContentBox>
                      <TextField
                        id='state'
                        type='text'
                        margin='dense'
                        size='small'
                        label='State'
                        required
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={updateValue.state}
                      />
                    </ContentBox>
                    <ContentBox>
                      <TextField
                        id='selfWeight'
                        type='number'
                        margin='dense'
                        size='small'
                        label='Self Weight'
                        required
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={updateValue.selfWeight}
                      />
                    </ContentBox>
                    <ContentBox>
                      <TextField
                        id='labourCharge'
                        type='number'
                        margin='dense'
                        size='small'
                        label='Labour Charge'
                        required
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={updateValue.labourCharge}
                      />
                    </ContentBox>
                    <ContentBox>
                      {updateValue.orderType.toLowerCase() === 'job-work' &&
                        updateValue.state.toLowerCase() === 'gujarat' && (
                          <TextField
                            id='cgstValue'
                            type='number'
                            margin='dense'
                            size='small'
                            label='CGST Value'
                            InputLabelProps={{ shrink: true }}
                            sx={{ my: 1, width: '80%' }}
                            variant='standard'
                            value={updateValue.cgstValue}
                          />
                        )}
                      {updateValue.orderType.toLowerCase() === 'self' &&
                        updateValue.state.toLowerCase() === 'gujarat' && (
                          <TextField
                            id='lcgstValue'
                            type='number'
                            margin='dense'
                            size='small'
                            label='L-CGST Value'
                            InputLabelProps={{ shrink: true }}
                            sx={{ my: 1, width: '80%' }}
                            variant='standard'
                            value={updateValue.lcgstValue}
                          />
                        )}
                      {updateValue.orderType.toLowerCase() === 'job-work' &&
                        updateValue.state.toLowerCase() !== 'gujarat' && (
                          <TextField
                            id='igstValue'
                            type='number'
                            margin='dense'
                            size='small'
                            label='IGST Value'
                            InputLabelProps={{ shrink: true }}
                            sx={{ my: 1, width: '80%' }}
                            variant='standard'
                            value={updateValue.igstValue}
                          />
                        )}
                      {updateValue.orderType.toLowerCase() === 'self' &&
                        updateValue.state.toLowerCase() !== 'gujarat' && (
                          <TextField
                            id='ligstValue'
                            type='number'
                            margin='dense'
                            size='small'
                            label='L-IGST value'
                            InputLabelProps={{ shrink: true }}
                            sx={{ my: 1, width: '80%' }}
                            variant='standard'
                            value={updateValue.ligstValue}
                          />
                        )}
                    </ContentBox>
                    <ContentBox>
                      {updateValue.orderType.toLowerCase() === 'job-work' &&
                        updateValue.state.toLowerCase() === 'gujarat' && (
                          <TextField
                            id='sgstValue'
                            type='number'
                            margin='dense'
                            size='small'
                            label='SGST Value'
                            InputLabelProps={{ shrink: true }}
                            sx={{ my: 1, width: '80%' }}
                            variant='standard'
                            value={updateValue.sgstValue}
                          />
                        )}
                      {updateValue.orderType.toLowerCase() === 'self' &&
                        updateValue.state.toLowerCase() === 'gujarat' && (
                          <TextField
                            id='lsgstValue'
                            type='number'
                            margin='dense'
                            size='small'
                            label='L-SGST Value'
                            InputLabelProps={{ shrink: true }}
                            sx={{ my: 1, width: '80%' }}
                            variant='standard'
                            value={updateValue.lsgstValue}
                          />
                        )}
                      {updateValue.orderType.toLowerCase() === 'self' &&
                        updateValue.state.toLowerCase() !== 'gujarat' && (
                          <TextField
                            id='digstValue'
                            type='number'
                            margin='dense'
                            size='small'
                            label='D-IGST value'
                            InputLabelProps={{ shrink: true }}
                            sx={{ my: 1, width: '80%' }}
                            variant='standard'
                            value={updateValue.digstValue}
                          />
                        )}
                    </ContentBox>
                    <ContentBox>
                      {updateValue.orderType.toLowerCase() === 'self' &&
                        updateValue.state.toLowerCase() === 'gujarat' && (
                          <TextField
                            id='dcgstValue'
                            type='number'
                            margin='dense'
                            size='small'
                            label='D-CGST Value'
                            InputLabelProps={{ shrink: true }}
                            sx={{ my: 1, width: '80%' }}
                            variant='standard'
                            value={updateValue.dcgstValue}
                          />
                        )}
                    </ContentBox>
                    <ContentBox>
                      {updateValue.orderType.toLowerCase() === 'self' &&
                        updateValue.state.toLowerCase() === 'gujarat' && (
                          <TextField
                            id='dsgstValue'
                            type='number'
                            margin='dense'
                            size='small'
                            label='D-SGST Value'
                            InputLabelProps={{ shrink: true }}
                            sx={{ my: 1, width: '80%' }}
                            variant='standard'
                            value={updateValue.dsgstValue}
                          />
                        )}
                    </ContentBox>

                    <ContentBox>
                      {updateValue.orderType.toLocaleLowerCase() === 'self' && (
                        <TextField
                          id='diamondPrice'
                          type='number'
                          margin='dense'
                          size='small'
                          label='Diamond Price'
                          required
                          InputLabelProps={{ shrink: true }}
                          sx={{ my: 1, width: '80%' }}
                          variant='standard'
                          value={updateValue.diamondPrice}
                        />
                      )}
                    </ContentBox>
                    <ContentBox>
                      <TextField
                        id='extraCost'
                        type='number'
                        margin='dense'
                        size='small'
                        label='Extra Cost'
                        required
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={updateValue.extraCost}
                        onChange={(e) => {
                          setUpdateValue({ ...updateValue, extraCost: e.target.value });
                        }}
                      />
                    </ContentBox>
                    <ContentBox>
                      {updateValue.state.toLowerCase() === 'gujarat' &&
                        (updateValue.orderType.toLowerCase() === 'job-work' ||
                          updateValue.orderType.toLowerCase() === 'self') && (
                          <TextField
                            id='extraCostCgstValue'
                            type='number'
                            margin='dense'
                            size='small'
                            label='Extra-Cost-CGST Value'
                            InputLabelProps={{ shrink: true }}
                            sx={{ my: 1, width: '80%' }}
                            variant='standard'
                            value={updateValue.extraCostCgstValue}
                          />
                        )}
                      {(updateValue.orderType.toLowerCase() === 'job-work' ||
                        updateValue.orderType.toLowerCase() === 'self') &&
                        updateValue.state.toLowerCase() !== 'gujarat' && (
                          <TextField
                            id='extraCostIgstValue'
                            type='number'
                            margin='dense'
                            size='small'
                            label='Extra-Cost-IGST Value'
                            InputLabelProps={{ shrink: true }}
                            sx={{ my: 1, width: '80%' }}
                            variant='standard'
                            value={updateValue.extraCostIgstValue}
                          />
                        )}
                    </ContentBox>
                    <ContentBox>
                      {updateValue.state.toLowerCase() === 'gujarat' &&
                        (updateValue.orderType.toLowerCase() === 'job-work' ||
                          updateValue.orderType.toLowerCase() === 'self') && (
                          <TextField
                            id='extraCostSgstValue'
                            type='number'
                            margin='dense'
                            size='small'
                            label='Extra-Cost-SGST Value'
                            InputLabelProps={{ shrink: true }}
                            sx={{ my: 1, width: '80%' }}
                            variant='standard'
                            value={updateValue.extraCostSgstValue}
                          />
                        )}
                    </ContentBox>
                    <ContentBox>
                      <TextField
                        multiline
                        maxRows={4}
                        id='remark'
                        type='text'
                        margin='dense'
                        size='small'
                        label='Remark'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={updateValue.remark}
                        onChange={(e) => {
                          setUpdateValue({ ...updateValue, remark: e.target.value });
                        }}
                      />
                    </ContentBox>
                    <ContentBox>
                      <TextField
                        id='mobileNumber'
                        type='text'
                        margin='dense'
                        size='small'
                        label='Mobile Number'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={updateValue.mobileNumber}
                        onChange={(e) => {
                          setUpdateValue({ ...updateValue, mobileNumber: e.target.value });
                        }}
                      />
                    </ContentBox>
                    <ContentBox>
                      <TextField
                        id='total'
                        type='number'
                        margin='dense'
                        size='small'
                        label='Total'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={updateValue.total}
                      />
                    </ContentBox>
                    <ContentBox>
                      <TextField
                        id='gstNumber'
                        type='text'
                        margin='dense'
                        size='small'
                        label='GST Number'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={updateValue.gstNumber}
                      />
                    </ContentBox>
                  </Grid>
                  <Grid item xs={12}>
                    <ContentBox>
                      <TextField
                        multiline
                        maxRows={4}
                        id='address'
                        type='text'
                        margin='dense'
                        size='small'
                        label='Address'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '90%', ml: '2%' }}
                        variant='standard'
                        value={updateValue.address}
                        onChange={(e) => {
                          setUpdateValue({ ...updateValue, address: e.target.value });
                        }}
                      />
                    </ContentBox>
                  </Grid>
                </Grid>
              </StyledCard>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button variant='standard' color='secondary' onClick={onClose}>
            Cancel
          </Button>
          <LoadingButton
            onClick={handleUpdate}
            color='primary'
            loading={loading}
            variant='contained'
            sx={{ my: 2 }}
          >
            Update Invoice
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
